import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ControllerProps } from 'src/router';
import { ObjectUtils } from 'src/core/utils/object';
import { ContextService } from 'src/core/services/context.service';
import { AirportDataService } from 'src/app/general/airports/form/airport-form.data';
import { PlaceFormView } from './place-form.view';
import { PlaceDataService } from './place-form.data';
import { ConfigurationService } from 'src/core/services/configuration.service';

interface PlaceFormParams {
	id: string;
	type: string;
}

@observer
export class PlaceFormController extends React.Component<ControllerProps<PlaceFormParams>, any> {
	@resolve
	protected contextService: ContextService;

	@observable
	protected dataService: PlaceDataService | AirportDataService;

	@resolve
	protected toast: ToastNotifications;

	@observable
	mode: ControlMode = 'display';

	@resolve
	protected configurationService: ConfigurationService;

	@observable
	defaultLanguaje: string;

	constructor(props) {
		super(props);
	}

	@computed
	protected get title() {
		if (this.dataService && this.dataService.item && this.dataService.item.dynamicProperties['displayName'] != null && this.dataService.item.dynamicProperties['displayName'][this.defaultLanguaje] != null)
			return `Place ${this.dataService.item.dynamicProperties['displayName'][this.defaultLanguaje]}`;
		else return '';
	}

	@autobind
	protected onModeChanged(mode: ControlMode) {
		this.mode = mode;
	}

	@autobind
	protected create() {
		const place: any = this.dataService.add(this.defaultLanguaje, this.props.match.params.type);
		return place;
	}

	@autobind
	public async save() {
		const item = this.dataService.item;
		const errors = await item.validate(true);
		if (errors.length == 0) {
			this.props.setBusy(true);

			this.dataService.save()
				.then(() => {
					this.props.setBusy(false);
					this.onModeChanged('display');
					this.toast.showDataSaved();
					this.props.history.replace(`/general/places`);
				})
				.catch((error) => {
					this.props.setBusy(false);
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				});
		} else {
			this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
		}
	}

	@autobind
	public cancel() {
		this.props.history.push('/general/places');
	}

	componentDidMount() {
		this.dataService = this.props.match.params.type != 'Airport' ? PlaceDataService.make(this.contextService) : AirportDataService.make(this.contextService);

		this.props.setBusy(true);
		let create = this.props.match.params.id == 'new';
		this.configurationService.current()
			.then(res => {
				this.defaultLanguaje = res.defaultLanguage;
				if (create) {
					// Create new
					(this.dataService as any).create(this.create)
						.then(() => {
							this.mode = 'edit';
							this.props.setBusy(false);
						})
						.catch((error) => {
							this.props.setBusy(false);
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						});

				} else {
					this.dataService.addFilter('id', 'eq', this.props.match.params.id);
					this.dataService.addSorting('id', 'asc', true);
					this.dataService.pageSize = 1;
					(this.dataService as any).load(query => query)
						.catch((error) => {
							this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
						})
						.then(() => {
							this.props.setBusy(false);
						});
				}
			});
	}

	render() {
		if (this.dataService == null || this.dataService.item == null) {
			return null;
		}

		let model = this.dataService.item;

		return (
			<PlaceFormView
				title={this.title}
				mode={this.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				model={model}
				setBusy={this.props.setBusy}
				contextService={this.contextService}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/places/form/place-form.controller.tsx